<template lang="pug">
input(
  type="hidden"
  :value="value"
  :name="name"
)
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: null,
    },

    name: {
      type: [String, Boolean],
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// Hidden.vue?16983f68